import { useQuery } from "@tanstack/react-query";
import { resolveBrandedSignupPage } from "api";

export const useResolveBrandedSignupPage = (pageId) =>
  useQuery({
    queryKey: ["resolve-branded-signup-page", pageId],
    queryFn: () => resolveBrandedSignupPage(pageId),
    enabled: !!pageId,
  });
